var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.98 31.42C53.3 31.14 52.4 31 51.28 31H40.72C37.24 31 36 32.24 36 35.76V51.24C36 52.4 36.14 53.3 36.44 54C37.06 55.44 38.38 56 40.72 56H51.28C54.76 56 56 54.74 56 51.24V35.76C56 33.38 55.44 32.04 53.98 31.42ZM48 51.5H44C43.96 51.5 43.9 51.5 43.86 51.48C43.56 51.46 43.3 51.36 43.08 51.16C42.72 50.9 42.5 50.48 42.5 50C42.5 49.18 43.18 48.5 44 48.5H48C48.82 48.5 49.5 49.18 49.5 50C49.5 50.82 48.82 51.5 48 51.5Z",
    fill: "#ED6E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.98 24.38V26C53.98 27.1 53.08 28 51.98 28H40.72C35.6 28 33 30.62 33 35.76V54C33 55.1 32.1 56 31 56H27.1C26.3 56 25.66 55.36 25.66 54.58C25.66 53.78 26.3 53.16 27.1 53.16H31V45.5H24C19.56 45.28 16.02 41.62 16.02 37.12V24.38C16.02 19.76 19.78 16 24.42 16H45.6C50.22 16 53.98 19.76 53.98 24.38Z",
    fill: "#ED6E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorMobile);
export default __webpack_public_path__ + "static/media/monitor-mobile.20ab49944a3bfeb46b5df63d04468baa.svg";
export { ForwardRef as ReactComponent };